export default __webpack_public_path__ + "static/authenticalove-961e51ae123f2394b3dae3086b51f8ff.png";